import TaxRepList from '@/pages/components/manage/other/tax-rep/TaxRepList';

export default {
    list: TaxRepList,
};
